import React from 'react';

const testimonials = [
  {
    name: 'Sophie M.',
    title: 'Travel Agency Owner',
    quote: 'The AI Itinerary Builder saves us hours every day. Earlier, our agents spent 30–40 minutes preparing an itinerary. Now, with AI, it takes less than a minute.',
  },
  {
    name: 'Rahul K.',
    title: 'Corporate Travel Consultant',
    quote: 'Flight & hotel comparison boosted our sales. With multiple suppliers in one click, we always find the best deals. Booking conversions are up 25% in 3 months.',
  },
  {
    name: 'Maria L.',
    title: 'Leisure Travel Manager',
    quote: 'The WhatsApp chatbot changed our service. Clients get instant answers and can book on WhatsApp. Calls are down 40%, and repeat bookings are up.',
  },
];

const TestimonialCard = ({ name, title, quote }) => (
  <div className="col-lg-4 mb-4">
    <div className="card h-100 border-0 shadow-sm">
      <div className="card-body p-4">
        <div className="d-flex mb-3">
          <span className="text-warning">★★★★★</span>
        </div>
        <p className="text-muted fst-italic">"{quote}"</p>
        <div className="mt-4">
          <h6 className="fw-bold mb-0">{name}</h6>
          <small className="text-muted">{title}</small>
        </div>
      </div>
    </div>
  </div>
);

export default function TestimonialsSection() {
  return (
    <section className="py-5" style={{ backgroundColor: '#FFFFFF' }}>
      <div className="container">
        <div className="row justify-content-center text-center mb-5">
          <div className="col-lg-8">
            <h2 className="display-5 fw-bold">Trusted by Agencies Worldwide</h2>
            <p className="fs-5 text-muted">Genuine feedback from travel agencies who use our platform daily.</p>
          </div>
        </div>
        <div className="row">
          {testimonials.map((testimonial, index) => (
            <TestimonialCard key={index} {...testimonial} />
          ))}
        </div>
      </div>
    </section>
  );
}